import { ENV_PRODUCTION, ENV_TESTNET } from 'constants/env';
import { LS_ENV_NAME } from 'constants/local-storage';
import { CONTRACTS } from 'constants/soroban';
import { NETWORK_PASSPHRASES } from 'constants/stellar';

import { Environment } from 'types/env';

export const getEnv = (): Environment => {
    const env = localStorage.getItem(LS_ENV_NAME);
    return (env as Environment) || ENV_TESTNET;
};
export const getIsTestnetEnv = () => getEnv() === ENV_TESTNET;
export const getIsProductionEnv = () => getEnv() === ENV_PRODUCTION;
export const setTestnetEnv = () => {
    localStorage.setItem(LS_ENV_NAME, ENV_TESTNET);
    window.location.reload();
};
export const setProductionEnv = () => {
    localStorage.setItem(LS_ENV_NAME, ENV_PRODUCTION);
    window.location.reload();
};

export const getNetworkPassphrase = () => NETWORK_PASSPHRASES[getEnv()];

// The ICE Locker is used only on a network with a configured Locker contract; elsewhere AQUA
// locks are Classic claimable balances.
export const getIsLockerEnabled = () => Boolean(CONTRACTS[getEnv()].tokenTimelock);
